import { unsupportedEmailFileTypes } from 'shared/constants/email'

export const MESSAGES_TAKE_COUNT = 15

export const MESSAGE_MAX_FILE_SIZE = 80000000 // 80MB

export const unsupportedMessageFileTypes = unsupportedEmailFileTypes
/**
 * This gets sent to the backend as responsibleNavneregisterId when creating a new thread,
 * and when setting responsible manually, and is used as compare value when filtering on 'styret'
 */
export const MESSAGE_RESPONSIBLE_BOARD = 'styret'
